module.exports = __webpack_public_path__ + "img/shouye_gouwu@2x.e80d9c9e.png";